<template>
    <section class="forms component-d0b82bdc" resmed-component-name="contact_form"
        v-bind:style="{
            'background-image': `url(${acf.image})`,
            'background-color': `${acf.background_color}`
        }">
        <div class="container">
            <div class="row">
                <div class="col">

			        <div class="items mb-4" v-if="!complete">
			            <div class="item card">

							<eyebrow-icon v-if="acf.eyebrowicon" v-bind:eyebrowicon="acf.eyebrowicon" v-bind:align="'center'"></eyebrow-icon>

			                <h2 v-html="acf.headline" v-bind:align="'center'"></h2>

			                <p v-html="acf.subheadline" v-bind:align="'center'"></p>

			            </div>
			        </div>

                    <component v-bind:is="active"></component>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import forms from '../forms/index';

    export default {
        name: 'forms',
        data(){
          return {
            complete : false
          }
        },
        components: {
            ...forms
        },
        props: ['acf','name','origin'],
        computed: {
            active() {
                const name = this.name.replace(/\s/, '-').toLowerCase();
                return `form-${name}`;
            }
        }
    }
</script>

<style lang="scss" scoped>

	.-validation {
		font-style:bold;
		text-align:right;

	}

	.component-d0b82bdc {
		clear:both;
		padding-top:88px;
		padding-bottom:30px;
        background-size: contain;
        background-position: center top;
        background-repeat: no-repeat;
	}

	.eyebrow {
	  width: 20px;
	  height: 3px;
	  border-radius: 5.5px;
	  background-color: #0c0c0c;
	  margin:auto;
	  margin-bottom:35px;
	}

	.space{
		margin-bottom:50px;
	}


</style>
